var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPhilippine(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 20,
    viewBox: "0 0 29 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 28,
    height: 19,
    stroke: "#5754E5",
    strokeOpacity: 0.15
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 10H28V19H1L1 10Z",
    fill: "#CE1126"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1 1H28V10H1V1Z",
    fill: "#0038A8"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5884 10L1 19V1L16.5884 10Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.60078 11.8C7.59489 11.8 8.40078 10.9941 8.40078 9.99995C8.40078 9.00584 7.59489 8.19995 6.60078 8.19995C5.60667 8.19995 4.80078 9.00584 4.80078 9.99995C4.80078 10.9941 5.60667 11.8 6.60078 11.8Z",
    fill: "#FCD116"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M6.60155 9.99995L5.96875 6.81815L6.15775 6.62895L6.60155 9.99995ZM6.60155 9.99995L6.36775 6.43375L6.60155 6.19995L6.83535 6.43375L6.60155 9.99995ZM6.60155 9.99995L7.04535 6.62895L7.23435 6.81815L6.60155 9.99995Z",
    fill: "#FCD116"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M6.60158 9.99993L7.23438 13.1817L7.04538 13.3709L6.60158 9.99993ZM6.60158 9.99993L6.83538 13.5661L6.60158 13.7999L6.36778 13.5661L6.60158 9.99993ZM6.60158 9.99993L6.15778 13.3709L5.96878 13.1817L6.60158 9.99993Z",
    fill: "#FCD116"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M6.59844 9.99999L9.78024 9.36719L9.96944 9.55619L6.59844 9.99999ZM6.59844 9.99999L10.1646 9.76619L10.3984 9.99999L10.1646 10.2338L6.59844 9.99999ZM6.59844 9.99999L9.96944 10.4438L9.78024 10.6328L6.59844 9.99999Z",
    fill: "#FCD116"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M6.60078 10L3.41898 10.6328L3.22978 10.4438L6.60078 10ZM6.60078 10L3.03458 10.2338L2.80078 10L3.03458 9.76621L6.60078 10ZM6.60078 10L3.22978 9.55621L3.41898 9.36721L6.60078 10Z",
    fill: "#FCD116"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M6.6003 9.99994L8.40271 7.30261L8.67014 7.30247L6.6003 9.99994ZM6.6003 9.99994L8.95666 7.31294L9.2873 7.31294L9.2873 7.64358L6.6003 9.99994ZM6.6003 9.99994L9.29777 7.9301L9.29762 8.19753L6.6003 9.99994Z",
    fill: "#FCD116"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M6.60283 9.99994L4.80041 12.6973L4.53299 12.6974L6.60283 9.99994ZM6.60283 9.99994L4.24647 12.6869L3.91582 12.6869L3.91582 12.3563L6.60283 9.99994ZM6.60283 9.99994L3.90536 12.0698L3.9055 11.8024L6.60283 9.99994Z",
    fill: "#FCD116"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M6.60382 9.99995L9.30115 11.8024L9.30129 12.0698L6.60382 9.99995ZM6.60382 9.99995L9.29082 12.3563L9.29082 12.687L8.96018 12.687L6.60382 9.99995ZM6.60382 9.99995L8.67366 12.6974L8.40623 12.6973L6.60382 9.99995Z",
    fill: "#FCD116"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M6.60321 9.99992L3.90588 8.19751L3.90574 7.93008L6.60321 9.99992ZM6.60321 9.99992L3.91621 7.64356L3.91621 7.31292L4.24685 7.31292L6.60321 9.99992ZM6.60321 9.99992L4.53337 7.30245L4.8008 7.3026L6.60321 9.99992Z",
    fill: "#FCD116"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M14.7895 9.99995L14.1131 10.2352L14.0985 10.951L13.6659 10.3804L12.9805 10.5878L13.3895 9.99995L12.9805 9.41215L13.6659 9.61955L14.0985 9.04895L14.1131 9.76475L14.7895 9.99995Z",
    fill: "#FCD116"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M1.90082 17.4411L2.03533 16.7377L1.42273 16.3672L2.13318 16.2778L2.29627 15.5806L2.60082 16.2287L3.31437 16.1684L2.79205 16.6582L3.06991 17.3182L2.44271 16.9729L1.90082 17.4411Z",
    fill: "#FCD116"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M1.89956 2.55893L2.44145 3.02711L3.06865 2.68186L2.79079 3.3418L3.31311 3.83167L2.59956 3.77137L2.29501 4.41947L2.13192 3.7222L1.42147 3.63286L2.03407 3.26231L1.89956 2.55893Z",
    fill: "#FCD116"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhilippine);
export default __webpack_public_path__ + "static/media/philippine.0868180d0de2c0d4ce06029a52267e84.svg";
export { ForwardRef as ReactComponent };